import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import img9 from "./Assets/9.png";
import img10 from "./Assets/10.png";
import logo from "./Assets/zeus.png";

export default class ZeusThunderTowerConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];
        this.logo = logo;

        //Game Name
        this.name = "Zeus Thunder Tower";

        //General Config
        this.reels = 5;
        this.symbolPerReel = 3;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        this.highestSymId = 10;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
        return {
            94: {
                reductionWeight1M: 15112,
            },
            96: {
                weights: {
                    baseGame: [37676, 12870, 6000, 6000, 6000, 6000, 6000, 4863, 4864, 4864, 4863, 100000],
                    freeSpins: {},
                },
                reelSets: {
                    0: [
                        [
                            0, 2, 4, 1, 6, 2, 8, 4, 5, 3, 2, 0, 7, 2, 0, 6, 0, 0, 2, 1, 0, 3, 7, 2, 0, 1, 6, 4, 2, 5, 4,
                            0, 6, 4,
                        ],
                        [
                            3, 4, 1, 7, 0, 3, 1, 5, 7, 1, 1, 3, 5, 1, 8, 5, 3, 6, 1, 7, 3, 5, 0, 1, 0, 3, 2, 1, 6, 4, 3,
                            7, 5, 2, 1,
                        ],
                        [
                            0, 7, 2, 6, 4, 3, 7, 4, 5, 1, 0, 6, 0, 1, 2, 4, 3, 2, 0, 6, 8, 1, 5, 7, 0, 2, 1, 5, 3, 0, 5,
                            4, 3, 6, 7, 1, 0, 3, 2, 7, 1, 5, 6, 4, 2,
                        ],
                        [
                            2, 3, 0, 6, 4, 1, 8, 0, 2, 1, 1, 6, 2, 7, 4, 3, 5, 0, 1, 7, 5, 2, 1, 6, 7, 2, 3, 5, 2, 0, 4,
                            7, 1, 6, 0, 3, 5, 6, 4, 3, 1, 7, 5, 0, 4,
                        ],
                        [
                            3, 0, 6, 2, 1, 4, 5, 0, 2, 7, 1, 0, 0, 3, 4, 7, 6, 2, 1, 5, 1, 0, 3, 7, 5, 2, 4, 1, 6, 2, 4,
                            0, 3, 2, 6, 1, 7, 5, 8, 2, 1, 6, 3, 0, 7, 5, 4,
                        ],
                    ],
                    1: [
                        [
                            0, 2, 6, 10, 4, 0, 8, 2, 0, 10, 6, 4, 10, 2, 6, 10, 7, 2, 10, 4, 2, 10, 0, 2, 10, 0, 2, 10,
                            3, 0, 6, 1, 4, 0, 5, 4,
                        ],
                        [3, 1, 5, 7, 1, 6, 3, 1, 5, 3, 7, 1, 8, 3, 1, 7, 3, 1, 5, 3, 0, 1, 5, 3, 7, 2, 4],
                        [
                            0, 3, 2, 10, 5, 4, 10, 7, 2, 10, 3, 0, 10, 1, 4, 10, 6, 5, 10, 1, 7, 10, 6, 0, 10, 3, 1, 8,
                            4, 5, 2, 7, 6, 2, 1, 3, 7, 5, 0, 6, 4, 2, 3, 7, 1, 6, 0, 5, 4,
                        ],
                        [
                            2, 3, 4, 1, 6, 7, 8, 0, 2, 6, 7, 5, 3, 1, 0, 5, 4, 6, 7, 5, 3, 1, 0, 2, 4, 5, 3, 0, 2, 7, 6,
                            4, 1, 3, 2, 4, 1, 6, 7, 5, 0,
                        ],
                        [
                            3, 1, 2, 10, 0, 6, 10, 4, 2, 10, 7, 1, 10, 3, 5, 10, 0, 4, 10, 6, 5, 10, 7, 0, 10, 3, 4, 1,
                            5, 7, 6, 8, 2, 1, 6, 4, 1, 2, 7, 5, 0, 3, 7, 5, 6, 3, 0, 2, 4,
                        ],
                    ],
                    2: [
                        [
                            0, 2, 6, 9, 9, 9, 4, 0, 8, 2, 0, 9, 9, 9, 6, 4, 9, 9, 9, 2, 6, 9, 9, 9, 7, 2, 9, 9, 9, 4, 2,
                            9, 9, 9, 0, 2, 9, 9, 9, 0, 2, 9, 9, 9, 3, 0, 6, 1, 4, 0, 5, 4,
                        ],
                        [
                            3, 4, 1, 7, 0, 3, 1, 5, 7, 1, 1, 3, 5, 1, 8, 5, 3, 6, 1, 7, 3, 5, 0, 1, 0, 3, 2, 1, 6, 4, 3,
                            7, 5, 2, 1,
                        ],
                        [
                            0, 7, 2, 6, 4, 3, 7, 4, 5, 1, 0, 6, 0, 1, 2, 4, 3, 2, 0, 6, 8, 1, 5, 7, 0, 2, 1, 5, 3, 0, 5,
                            4, 3, 6, 7, 1, 0, 3, 2, 7, 1, 5, 6, 4, 2,
                        ],
                        [
                            2, 3, 0, 6, 4, 1, 8, 0, 2, 1, 1, 6, 2, 7, 4, 3, 5, 0, 1, 7, 5, 2, 1, 6, 7, 2, 3, 5, 2, 0, 4,
                            7, 1, 6, 0, 3, 5, 6, 4, 3, 1, 7, 5, 0, 4,
                        ],
                        [
                            3, 0, 6, 2, 1, 4, 5, 0, 2, 7, 1, 0, 0, 3, 4, 7, 6, 2, 1, 5, 1, 0, 3, 7, 5, 2, 4, 1, 6, 2, 4,
                            0, 3, 2, 6, 1, 7, 5, 8, 2, 1, 6, 3, 0, 7, 5, 4,
                        ],
                    ],
                    3: [
                        [
                            0, 2, 4, 1, 6, 2, 8, 4, 5, 3, 2, 0, 7, 2, 0, 6, 0, 0, 2, 1, 0, 3, 7, 2, 0, 1, 6, 4, 2, 5, 4,
                            0, 6, 4,
                        ],
                        [
                            3, 1, 9, 9, 9, 5, 7, 1, 9, 9, 9, 6, 3, 9, 9, 9, 1, 5, 3, 7, 9, 9, 9, 1, 8, 3, 9, 9, 9, 1, 7,
                            3, 1, 5, 3, 9, 9, 9, 0, 1, 5, 3, 7, 2, 4,
                        ],
                        [
                            0, 7, 2, 6, 4, 3, 7, 4, 5, 1, 0, 6, 0, 1, 2, 4, 3, 2, 0, 6, 8, 1, 5, 7, 0, 2, 1, 5, 3, 0, 5,
                            4, 3, 6, 7, 1, 0, 3, 2, 7, 1, 5, 6, 4, 2,
                        ],
                        [
                            2, 3, 0, 6, 4, 1, 8, 0, 2, 1, 1, 6, 2, 7, 4, 3, 5, 0, 1, 7, 5, 2, 1, 6, 7, 2, 3, 5, 2, 0, 4,
                            7, 1, 6, 0, 3, 5, 6, 4, 3, 1, 7, 5, 0, 4,
                        ],
                        [
                            3, 0, 6, 2, 1, 4, 5, 0, 2, 7, 1, 0, 0, 3, 4, 7, 6, 2, 1, 5, 1, 0, 3, 7, 5, 2, 4, 1, 6, 2, 4,
                            0, 3, 2, 6, 1, 7, 5, 8, 2, 1, 6, 3, 0, 7, 5, 4,
                        ],
                    ],
                    4: [
                        [
                            0, 2, 4, 1, 6, 2, 8, 4, 5, 3, 2, 0, 7, 2, 0, 6, 0, 0, 2, 1, 0, 3, 7, 2, 0, 1, 6, 4, 2, 5, 4,
                            0, 6, 4,
                        ],
                        [
                            3, 4, 1, 7, 0, 3, 1, 5, 7, 1, 1, 3, 5, 1, 8, 5, 3, 6, 1, 7, 3, 5, 0, 1, 0, 3, 2, 1, 6, 4, 3,
                            7, 5, 2, 1,
                        ],
                        [
                            0, 3, 2, 9, 9, 9, 5, 4, 9, 9, 9, 7, 2, 9, 9, 9, 3, 0, 9, 9, 9, 1, 4, 9, 9, 9, 6, 5, 9, 9, 9,
                            1, 7, 9, 9, 9, 6, 0, 9, 9, 9, 3, 1, 8, 4, 5, 2, 7, 6, 2, 1, 3, 7, 5, 0, 6, 4, 2, 3, 7, 1, 6,
                            0, 5, 4,
                        ],
                        [
                            2, 3, 0, 6, 4, 1, 8, 0, 2, 1, 1, 6, 2, 7, 4, 3, 5, 0, 1, 7, 5, 2, 1, 6, 7, 2, 3, 5, 2, 0, 4,
                            7, 1, 6, 0, 3, 5, 6, 4, 3, 1, 7, 5, 0, 4,
                        ],
                        [
                            3, 0, 6, 2, 1, 4, 5, 0, 2, 7, 1, 0, 0, 3, 4, 7, 6, 2, 1, 5, 1, 0, 3, 7, 5, 2, 4, 1, 6, 2, 4,
                            0, 3, 2, 6, 1, 7, 5, 8, 2, 1, 6, 3, 0, 7, 5, 4,
                        ],
                    ],
                    5: [
                        [
                            0, 2, 4, 1, 6, 2, 8, 4, 5, 3, 2, 0, 7, 2, 0, 6, 0, 0, 2, 1, 0, 3, 7, 2, 0, 1, 6, 4, 2, 5, 4,
                            0, 6, 4,
                        ],
                        [
                            3, 4, 1, 7, 0, 3, 1, 5, 7, 1, 1, 3, 5, 1, 8, 5, 3, 6, 1, 7, 3, 5, 0, 1, 0, 3, 2, 1, 6, 4, 3,
                            7, 5, 2, 1,
                        ],
                        [
                            0, 7, 2, 6, 4, 3, 7, 4, 5, 1, 0, 6, 0, 1, 2, 4, 3, 2, 0, 6, 8, 1, 5, 7, 0, 2, 1, 5, 3, 0, 5,
                            4, 3, 6, 7, 1, 0, 3, 2, 7, 1, 5, 6, 4, 2,
                        ],
                        [
                            2, 3, 4, 9, 9, 9, 1, 6, 9, 9, 9, 7, 8, 0, 2, 9, 9, 9, 6, 7, 5, 3, 9, 9, 9, 1, 0, 9, 9, 9, 5,
                            4, 6, 9, 9, 9, 7, 5, 3, 1, 0, 9, 9, 9, 2, 4, 5, 3, 0, 2, 7, 6, 4, 1, 3, 2, 4, 1, 6, 7, 5, 0,
                        ],
                        [
                            3, 0, 6, 2, 1, 4, 5, 0, 2, 7, 1, 0, 0, 3, 4, 7, 6, 2, 1, 5, 1, 0, 3, 7, 5, 2, 4, 1, 6, 2, 4,
                            0, 3, 2, 6, 1, 7, 5, 8, 2, 1, 6, 3, 0, 7, 5, 4,
                        ],
                    ],
                    6: [
                        [
                            0, 2, 4, 1, 6, 2, 8, 4, 5, 3, 2, 0, 7, 2, 0, 6, 0, 0, 2, 1, 0, 3, 7, 2, 0, 1, 6, 4, 2, 5, 4,
                            0, 6, 4,
                        ],
                        [
                            3, 4, 1, 7, 0, 3, 1, 5, 7, 1, 1, 3, 5, 1, 8, 5, 3, 6, 1, 7, 3, 5, 0, 1, 0, 3, 2, 1, 6, 4, 3,
                            7, 5, 2, 1,
                        ],
                        [
                            0, 7, 2, 6, 4, 3, 7, 4, 5, 1, 0, 6, 0, 1, 2, 4, 3, 2, 0, 6, 8, 1, 5, 7, 0, 2, 1, 5, 3, 0, 5,
                            4, 3, 6, 7, 1, 0, 3, 2, 7, 1, 5, 6, 4, 2,
                        ],
                        [
                            2, 3, 0, 6, 4, 1, 8, 0, 2, 1, 1, 6, 2, 7, 4, 3, 5, 0, 1, 7, 5, 2, 1, 6, 7, 2, 3, 5, 2, 0, 4,
                            7, 1, 6, 0, 3, 5, 6, 4, 3, 1, 7, 5, 0, 4,
                        ],
                        [
                            3, 1, 2, 9, 9, 9, 0, 6, 9, 9, 9, 4, 2, 9, 9, 9, 7, 1, 9, 9, 9, 3, 5, 9, 9, 9, 0, 4, 9, 9, 9,
                            6, 5, 9, 9, 9, 7, 0, 9, 9, 9, 3, 4, 1, 5, 7, 6, 8, 2, 1, 6, 4, 1, 2, 7, 5, 0, 3, 7, 5, 6, 3,
                            0, 2, 4,
                        ],
                    ],
                    7: [
                        [0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1, 0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1],
                        [3, 1, 5, 0, 1, 5, 3, 1, 7, 3, 1, 5, 0, 1, 5, 3, 1, 7],
                        [2, 7, 4, 6, 4, 2, 7, 4, 6, 2, 7, 2, 7, 4, 6, 4, 2, 7, 4, 6, 2, 7, 10],
                        [2, 3, 0, 6, 4, 1, 8, 0, 2, 1, 1, 0, 6, 4, 8, 0],
                        [3, 0, 6, 2, 1, 4, 5, 0, 2, 7, 1, 8, 0, 6, 10],
                    ],
                    8: [
                        [2, 4, 10, 4, 2, 4, 2, 10, 2, 7, 4, 10, 4, 2, 4, 7, 2, 4, 2, 10],
                        [2, 3, 0, 6, 4, 1, 5, 0, 2, 5, 1, 0, 6, 3, 1, 0],
                        [3, 0, 6, 3, 1, 5, 5, 0, 3, 7, 1, 5, 0, 6],
                        [0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1],
                        [3, 1, 5, 0, 1, 5, 3, 1, 7, 0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1],
                    ],
                    9: [
                        [3, 1, 5, 0, 1, 5, 3, 1, 7, 0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1, 4, 2],
                        [2, 1, 0, 1, 4, 1, 2, 0, 2, 1, 1, 0, 1, 4, 2, 0],
                        [7, 3, 5, 3, 6, 5, 5, 6, 3, 7, 6, 5, 7, 3, 5, 5, 10],
                        [0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1],
                        [2, 7, 4, 10, 4, 2, 7, 4, 7, 2, 7, 4, 2, 7, 4, 10, 4, 2, 7, 4, 7, 2, 7, 4, 2, 10],
                    ],
                    10: [
                        [2, 7, 4, 10, 4, 2, 7, 4, 7, 2, 7, 4, 2, 7, 4, 10, 4, 2, 7, 4, 7, 2, 7, 4, 2, 1],
                        [0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1],
                        [7, 3, 5, 3, 6, 0, 5, 6, 3, 7, 6, 0, 7, 3, 5, 0],
                        [2, 1, 0, 1, 4, 1, 8, 0, 2, 1, 1, 0, 1, 4, 2, 0],
                        [3, 1, 5, 0, 1, 5, 3, 1, 7, 0, 2, 4, 1, 6, 2, 0, 4, 5, 3, 2, 0, 4, 1, 4, 2, 10],
                    ],
                },
            },
        };
    }
}
